const translations = {
    title: 'Flight Overview'
};

export default translations;
